import { create } from "zustand";

import { checkLocationAccess, type LocationAccess } from "@/lib/location-access";

type LocationAccessStore = {
  access: LocationAccess;
  setAccess: (access: LocationAccess) => void;
  refresh: () => Promise<LocationAccess>;
};

// A web check can sit for up to 15s waiting on getCurrentPosition, so a later
// check can easily finish first. Only the newest result may write.
let latestRequest = 0;

/**
 * Live location availability, shared between the navigation guard and the
 * permissions screen. Starts at "checking" so the guard never redirects on a
 * state nobody has looked at yet.
 */
export const useLocationAccessStore = create<LocationAccessStore>((set) => ({
  access: "checking",

  setAccess: (access) => {
    latestRequest += 1;
    set({ access });
  },

  refresh: async () => {
    const request = (latestRequest += 1);
    const access = await checkLocationAccess();
    if (request === latestRequest) set({ access });
    return access;
  },
}));
